import { useEffect } from "react";
import { SITE_URL } from "@/lib/brand";

const DEFAULT_TITLE = "The Little Lantern Club · A little light, delivered monthly";

export const usePageMeta = (title, path) => {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    const link = document.querySelector('link[rel="canonical"]');
    if (link) link.href = `${SITE_URL}${path || "/"}`;
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.content = `${SITE_URL}${path || "/"}`;
  }, [title, path]);
};
